import { nanoid } from 'nanoid';
import { assignProperties } from '../../../../schemaUtils';
import { POLL_RATING_DIGITS as QuestionType } from '../../../../types/dialog.generated';
import { config } from './RatingDigitsPoll.config';

export function generateQuestion(_: unknown[], overrides: Partial<QuestionType['data']> = {}): QuestionType {
  return {
    id: nanoid(10),
    data: assignProperties<QuestionType['data']>(
      {
        type: config.name,
        text: '',
        minimumValue: 0,
        maximumValue: 5,
        hasGratitude: false,
        preset: 'rating',
        logicRules: [],
        goToRules: [],
      },
      overrides,
    ),
  };
}
